import dJSON from 'dirty-json';
import Splide from '@splidejs/splide';

(() => {
  const moduleSelector = '.module-hero';

  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove();
      const { data } = dJSON.parse(query.data);
      const listEl = query.querySelector('.splide__list');
      const splideEl = query.querySelector('.splide');

      data.forEach((item, index) => {
        const isFirstSlide = index === 0;
        let buttonsHtml;

        if (isFirstSlide) {
          buttonsHtml = /* html */ `
            <div class="module-hero__buttons logged-out-hide">
              <a class="module-hero__btn module-hero__btn--outline" href="${item.btnLink}">${item.btnText}</a>
            </div>
            <div class="module-hero__buttons logged-in-hide">
              <a class="module-hero__btn module-hero__btn--outline" href="/request-account">Create Account</a>
              <a class="module-hero__btn module-hero__btn--filled" href="/login">Login</a>
            </div>
          `;
        } else {
          buttonsHtml = /* html */ `
            <div class="module-hero__buttons">
              <a class="module-hero__btn module-hero__btn--outline" href="${item.btnLink}">${item.btnText}</a>
            </div>
          `;
        }

        listEl.insertAdjacentHTML('beforeend', /* html */ `
          <div class="splide__slide">
            <div class="module-hero__slide">
              <img class="module-hero__bg" src="${item.image}" alt="">
              <div class="module-hero__overlay"></div>
              <div class="module-hero__content">
                <h2 class="module-hero__title">${item.title}</h2>
                <p class="module-hero__description">${item.description}</p>
                ${buttonsHtml}
              </div>
            </div>
          </div>
        `);
      });

      const slideCount = data.length;
      const splideOptions = slideCount <= 1
        ? {
          type: 'slide', arrows: false, pagination: false, drag: false,
        }
        : {
          type: 'loop',
          arrows: true,
          pagination: true,
          drag: true,
        };

      new Splide(splideEl, splideOptions).mount();
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
